import React from 'react'
import { SpinnerDotted } from '../atoms'
import { no_data_icon } from '../../../assets/images'

const Table = ({ headers, customHeaders, data, tableschema, loading = false, custom_th = '', classes = '', tableClasses = '', tableHeight='100%', headerClasses = '', tableHeaderClasses = '', ...rest }) => {
  if (!headers) {
    return null
  }
  const tableHeaders = customHeaders || headers
  const check = ( data && data.length === 0 ) || loading
  return (
    <div className={`overflow-x-auto border border-gray-200 bg-white ${classes}`}>
      { custom_th && custom_th} 
      <table className={ `min-w-full divide-y divide-gray-200 table-fixed ${tableClasses}`} style={{height: tableHeight}}>
        <thead className={`bg-gray-200 ${tableHeaderClasses}`}>
          <tr>
            {!custom_th &&
              tableHeaders.map((item) => {
                return (
                  <th scope='col' key={item} className={`${headerClasses ? headerClasses : 'text-sm text-gray-600 py-4'} uppercase pl-3 pr-4 text-left  tracking-wider truncate`}>
                    {typeof item === 'string' ? item.replace(/_/g, ' ') : item}
                  </th>
                )
              })
            }
          </tr>
        </thead>
        <tbody className='bg-white divide-y'>
          {!check &&
            data.map((item, index) => {
              return tableschema({ data: item, headers, index, length: data.length, ...rest })
            })}
        </tbody>
      </table>
      { check && (
        <div className='grid grid-cols-1 py-16'>
          { !loading ?
            <React.Fragment>
              <img src={no_data_icon} alt='no-data-icon' className='h-14 w-16 inline-block  m-auto' />
              <span className='m-auto text-base font-semibold text-gray-600 mt-2'>No data found</span>
            </React.Fragment>
            :
            <SpinnerDotted classes='m-auto' />
          }
        </div>
      )}
    </div>
  )
}
Table.defaultProps = {
  tableClasses: '',
};

export default Table
